export default {
  name: 'SPÖ',
  versions:
    ["spoe/spoe_4.jpg", 'spoe/spoe_1.jpg', "spoe/spoe_2.jpg", "spoe/spoe_3.jpg"],
  containerStyle:
    {
      textAlign: 'left',
      paddingBottom:
        '10%',
      paddingLeft: '5%',
      paddingRight: '40%'
    }
  ,
  baseStyle: {
    fontFamily:
      'Arial',
    letterSpacing: '-2px',
    fontWeight:
      '600',
    padding:
      '3px 15px',
    lineHeight:
      '0.9',
    textShadow:
      '0px 0px 70px rgba(0,0,0,0.9)',
    position:
      'relative',
    top:
      '10px'
  }
  ,
  customStyles: [
    {
      name: "rot",
      style: {
        color: '#EC1B26'
      }
    },
    {
      name: "weiss",
      style: {
        color:
          '#FFF',
      }
    }
    ],
  linesDefault:
    [{
      text: 'Schaut her, schaut her ich hab einen Plan',
      style: 1,
      fontSize: 60
    }
    ]
}



// WEBPACK FOOTER //
// ./src/config/spoe.js